import { createFileRoute, redirect } from '@tanstack/react-router';
import App from '../../App';
import { getGdprAcknowledgementQueryOptions } from '../../core/services/queries/userSettingsQueries';
import { getDefaultModelQueryOptions } from '../../features/marketplace/services/queries/assistantApiQueries';

export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ location, context }) => {
    if (context.msalInstance.getAllAccounts().length === 0) {
      //TODO see if we can drill down on the active account
      // Serialize search object to query string
      const searchString =
        location.search && Object.keys(location.search).length > 0
          ? '?' + new URLSearchParams(location.search).toString()
          : '';
      const fullPath = location.pathname + searchString + (location.hash || '');
      throw redirect({
        to: '/auth',
        search: { redirect: fullPath },
      });
    }
  },
  loader: async ({ context }) => {
    const defaultModel = await context.queryClient.ensureQueryData(
      getDefaultModelQueryOptions()
    );

    await context.queryClient
      .ensureQueryData(getGdprAcknowledgementQueryOptions())
      .catch(() => null);

    return defaultModel;
  },
  component: App,
});
